import { IGatsbyImageDataObject } from '@et/types/Gatsby'
import React from 'react'
import PatternBonusHeader from './patternBonusHeader'
import { GatsbyImage } from 'gatsby-plugin-image'
import { LazyLoadImage } from 'react-lazy-load-image-component'
interface Props {
  image?: IGatsbyImageDataObject
  image2?: IGatsbyImageDataObject
}
function PatternBonus3(props: Props) {

  const { image, image2 } = props
  return (
    <div className='py-12 et-grid-basic lg:py-20 bg-cream-300'>

      {/* header */}
      <PatternBonusHeader
        subTitle='Bonus Module 3'
        title='Exporting your Patterns + Getting them Printed'
      />

      {/* IMAGE 1 */}
      {image && <div className='col-span-2 col-start-2 px-10 pt-4 pb-8 md:px-0 md:py-0 md:col-start-2 md:col-span-5 lg:col-start-3 lg:col-span-4 lg:pt-12 xl:col-start-4 xl:col-span-3 xl:pt-0'>
        <GatsbyImage image={image.gatsbyImageData} alt='Pattern Bonus 3' />
      </div>}

      <div className='col-span-2 col-start-2 md:flex md:flex-col md:justify-center md:col-start-7 md:col-span-7 md:pl-4 xl:col-start-7 xl:col-span-6'>
        <p className='mb-4 text-lg md:mb-0 lg:text-xl'>Let's get our patterns printed! In this module, I'll share my export settings: file type, size, resolution and color profile for getting our patterns printed on fabric and wallpaper through Spoonflower. I walk you through the entire upload process, the differences between ordering fabric vs. wallpaper + using their website's tools to order samples and larger quantities.</p>
      </div>

      <div className='col-span-2 col-start-2 pt-16 pb-8 md:p-[30px_20px_0] md:col-start-8 md:col-span-6 lg:col-start-9 lg:col-span-5 lg:pr-24 lg:pl-0 xl:col-start-9 xl:col-span-4'>
        <div className='max-w-[185px] w-full relative shadow-2xl md:mt-16'>
          <LazyLoadImage
            alt={
              'Pattern Bonus 3: Spoonflower wallpaper application'
            }
            className='relative w-full z-2'
            height={436}
            visibleByDefault={false}
            src={'https://et-teachable.imgix.net/procreate-patterns/wallpaper.gif'} // use normal <img> attributes as props
            width={350} />

          {image2 && <div className=' w-[225px] absolute top-[-75px] left-[70%] z-1 xl:left-[80%] xl:w-[350px] xl:top-[-100px]'>
            <GatsbyImage image={image2.gatsbyImageData} alt='Repeat pattern wallpaper hallway application' />
          </div>}
        </div>
      </div>

      <div className='col-span-2 col-start-2 md:col-start-2 md:col-span-6 md:row-start-3 md:p-[30px_0_0_0] md:flex md:flex-col md:justify-center lg:col-start-3 lg:col-span-6 xl:col-start-4 xl:col-span-5'>

        <p className='mb-4 text-lg lg:text-xl'>This module includes a buyer's guide video, sharing my experiences and recommendations for fabric and wallpaper with photos and color comparisons of the uploaded file vs. the samples I received.</p>

        <p className='mb-4 text-lg lg:text-xl'>We finish the module off with a timelapse + voice over narration of my experience applying their peel + stick wallpaper to a wall in my own home!</p>

      </div>


    </div>
  )
}

export default PatternBonus3